
import React from "react";
import ReactApexChart from "react-apexcharts";
import useChartColors from "Common/useChartColors";

function generateData(count: any, yrange: any) {
    var i = 0;
    var series = [];
    while (i < count) {
        var x = (i + 1).toString();
        var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

        series.push({
            x: x,
            y: y
        });
        i++;
    }
    return series;
}
const Basic = ({ chartId }: any) => {

    const chartColors = useChartColors(chartId);


    //Basic
    const series = [{
        name: 'Metric1',
        data: generateData(18, {
            min: 0,
            max: 90
        })
    },
    {
        name: 'Metric2',
        data: generateData(18, {
            min: 0,
            max: 90
        })
    },
    {
        name: 'Metric3',
        data: generateData(18, {
            min: 0,
            max: 90
        })
    },
    {
        name: 'Metric4',
        data: generateData(18, {
            min: 0,
            max: 90
        })
    },
    {
        name: 'Metric5',
        data: generateData(18, {
            min: 0,
            max: 90
        })
    },
    {
        name: 'Metric6',
        data: generateData(18, {
            min: 0,
            max: 90
        })
    },
    {
        name: 'Metric7',
        data: generateData(18, {
            min: 0,
            max: 90
        })
    },
    {
        name: 'Metric8',
        data: generateData(18, {
            min: 0,
            max: 90
        })
    },
    {
        name: 'Metric9',
        data: generateData(18, {
            min: 0,
            max: 90
        })
    }
    ];
    var options: any = {
        chart: {
            height: 350,
            type: 'heatmap',
        },
        dataLabels: {
            enabled: false
        },
        colors: chartColors,
    };
    return (

        <React.Fragment>
            <div className="col-span-4 card row-span-2 "> 
                        <h6 className=" p-2  text-15">Profit & Loss </h6>
                        <div className="relative   w-full">
                            <ReactApexChart
                                dir="ltr"
                                options={options}
                                series={series || []}
                                id={chartId}
                                className="apex-charts"
                                type="heatmap"
                            />
                        </div> 
           
            </div>
        </React.Fragment>
    );
};

export {
    Basic
};

